import { connect } from "react-redux";

var ReactTooltip = require("react-tooltip");

var CurrentUser = require("lib/account/CurrentUser");
var TextTypes = require("lib/academic/TextTypes")

var DataRouting = require("lib/routing/DataRouting");
var PaywallModal = require("components/users/teachers/PaywallModal");

var BookTextVariety = require("components/reading/books/BookTextVariety");
var ScoreDisplay = require("components/writing/evaluations/ScoreDisplay");
var BookDisplay = require("components/reading/books/BookDisplay")
var ReadingLevelDisplay = require("components/reading/reading_levels/ReadingLevelDisplay")
var ReadingLevelFormat = require("lib/academic/ReadingLevelFormat");

var RosterSelectors = require("lib/selectors/RosterSelectors");
var StudentDisplay = require("components/users/students/StudentDisplay");
var StudentListDisplay = require("components/org/student_lists/StudentListDisplay");
var WritingSelectors = require("lib/selectors/WritingSelectors");
var UIActions = require("lib/actions/UIActions");

require("reading/books/text_table.scss");

@connect(
	(state, props) => {
		var downProps = {}
		downProps.evaluationIDsByTextID = {}

		_.each(props.books, (book) => {
			//if the table has multiple students, find the last student to work on each book.
			var userID = props.userID || parseInt(_.max(_.keys(book.last_actives), (x) => Date.parse(book.last_actives[x])))

			var evaluation = WritingSelectors.evaluationBySubjectAttributes({
				state, subjectTextID: book.text_id, subjectUserID: userID
			});
			//make sure that answer evals aren't passed to the quiz column
			if (evaluation && evaluation.subject_type == "Quiz") {
				downProps.evaluationIDsByTextID[book.text_id] = evaluation.id;
			}
		})

		var student = RosterSelectors.student({ state, id: props.userID });
		if (student) {
			downProps.studentFirstName = student.first_name;
			downProps.studentReadingLevel = student.current_reading_level;
		}
		return downProps;
	},

	(dispatch, props) => ({
		onCellClick: (subjectType, textID) => {
			$wr.redirect(DataRouting.getPath(
				{ subjectType, textID, userIDs: [props.userID] }
			));
			$wr.setWindowY(0);
		}
	})
)

class TextTable extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		this.state = { expanded: false };
	}

	onCellClick(subjectType, book) {
		//if multiple users, make sure that the right id is grabbed
		var userID = this.props.userID || parseInt(_.max(_.keys(book.last_actives), (x) => Date.parse(book.last_actives[x])))

		$wr.redirect(DataRouting.getPath(
			{ subjectType, textID: book.text_id, userIDs: [userID] }
		));
		$wr.setWindowY(0);
	}

	expandFromSoftMax() {
		this.setState({ expanded: true });
	}

	render() {
		if (this.props.userID) {
			var books = _.sortBy(this.props.books, (b) => {
				return (b["last_actives"] || {})[this.props.userID] || "0"
			});
		} else {
			var books = _.sortBy(this.props.books, (b) => {
				return _.max(_.values(b.last_actives).map(function(x) {
					return Date.parse(x);
				}));
			});
		}
		books.reverse();

		if (this.props.softMax && (this.props.softMax < books.length) && !this.state.expanded) {
			books = _.first(books, this.props.softMax)
			var appliedSoftMax = true;
		} else {
			var appliedSoftMax = false;
		}

		var rows = _.map(books, (book) => {
			if (this.props.userID) {
				var userID = this.props.userID;
			} else {
				var userID = _.max(_.keys(book.last_actives), (x) => Date.parse(book.last_actives[x]))
			}
			if (book.title) {
				// All these things may not be initially present, but will be when the
				// detailed textData gets loaded in
				if (book.text_variety && TextTypes["Varieties"]["TYPES"][book.text_variety]) {
					var textVariety = TextTypes["Varieties"]["TYPES"][book.text_variety].abbreviation;
				} else {
					var textVariety = "-";
				}
				var textVariety = <BookTextVariety book={book} displayMode={"cell"}/>
				if (book.lexile_score) {
					var readingLevel = (
						<ReadingLevelDisplay studentReadingLevel={ this.props.studentReadingLevel } userID={userID} book={ book } 
							lexile={ book.lexile_score } displayMode={"cell"} showReadingLevelIcon />
					)
				} else {
					var readingLevel = (<td>-</td>);
				}
			} else {
				var textVariety = (<td />);
				var readingLevel = (<td />);
			}

			var evaluationID = this.props.evaluationIDsByTextID[book.text_id];

			if (evaluationID == undefined) {
				var evaluationCell = (
					<td><span className="pointsEarned">-</span></td>
				);
			} else {
				var expandQuizF = this.onCellClick.bind(this,
					DataRouting.SUBJECT_QUIZZES, book);

				var evaluationCell = (
					<td className="clickable" onClick={ expandQuizF }>
						<ScoreDisplay evaluationID={ evaluationID } mode={ ScoreDisplay.INLINE_MODE } />
						<a href="#" className="hideOnPrint"
							onClick={ $wr.preventDefaultBehavior }>
							View
						</a>
					</td>
				);
			}

			var activityCount = 0;
			var excludedCount = 0;

			_.each(book, (val, key) => {
				if (key.endsWith("_counts")) {
					activityCount += (book[key][userID] || 0);
				}
				if (key.endsWith("_counts_excluded")) {
					excludedCount += (book[key][userID] || 0);
				}
			})

			if (excludedCount > 0 && excludedCount < activityCount) {
				var className = "excludedStripes";
				var tooltipText = "Some activities have been excluded";
			} else if (excludedCount == activityCount) {
				var className = "excludedStripes";
				var tooltipText = "All activities have been excluded";
			}

			// There's now 3 cases
			// - excludedCount == 0: Nothing was excluded
			// - excludedCount < activityCount: Some activity was excluded, not other
			// - excludedCount == activityCount: All activity was exlcuede

			var countPairs = [
				[DataRouting.SUBJECT_ANSWERS, book.answer_counts],
				[DataRouting.SUBJECT_REVIEWS, book.review_counts],
			]

			if (this.props.showResponseCounts) {
				countPairs.push(
					[DataRouting.SUBJECT_ACTIVITIES, book.response_counts]
				);
			}

			var countCells = _.map(countPairs, (pair) => {
				var subjectType = pair[0];
				var count = (pair[1] || {})[userID];
				if (count) {
					var noun = subjectType.replace("Practice ", "");
					var expandCellF = this.onCellClick.bind(this, subjectType, book);
					return (
						<span key={ subjectType } onClick={ expandCellF }>
							{ $wr.pluralizeWithNumber(noun.slice(0, -1), count, noun) }
							<a href="#" className="hideOnPrint"
								onClick={ $wr.preventDefaultBehavior }>
								View
							</a>
							<br/>
						</span>	
					);
				} else {
					return (
						<span key={ subjectType } />
					);
				}
			});

			if (this.props.showLogStats) {
				var logSums = (book.log_sums || {})[userID] || {};
				if (logSums.minutes) {
					var minutesSum = (
						<span className="minutesContainer">
							{ logSums.minutes || 0 } min. <br/>
						</span>
					);	
				}
				if (logSums.pages) {
					var pagesSum = (
						<span>
							{ logSums.pages || 0 } pgs.
						</span>
					);	
				}
				var readingCell = (
					<td>
						{ minutesSum }
						{ pagesSum }
					</td>
				)
			}

			var lastActive = (book.last_actives || {})[userID];
			if (this.props.student) {
				var primaryStudentListID = this.props.student.student_list_ids.primary;
			}
			if (this.props.showStudentCell) {
				var studentInfoCell = (
					<td>
						<StudentDisplay studentID={ parseInt(userID) } showAvatar 
							avatarMaxWidth={ 30 } />
						<StudentListDisplay studentID={ parseInt(userID) } />
					</td>
				)	
			}

			return (
				<tr className={ "textRow " + className } key={ book.text_id } data-tip={ tooltipText }>
					<td>
						{ $wr.momentInTimezone(lastActive).format("MM/DD/YY") }
					</td>
					{ studentInfoCell }
					<td>
						<BookDisplay textID={ book.text_id } loadBook={ false } />
					</td>
					{ readingLevel }
					{ evaluationCell }
					<td className="writingCount">{ countCells }</td>
					{ readingCell }
				</tr>
			)
		});

		var cellCount = 7;

		if (this.props.showResponseCounts) {
			cellCount += 1;
			var responseHeader = (
				<th className="responseCol">
					Exercises
				</th>
			);
		}
		if (this.props.showLogStats) {
			cellCount += 2;
			var minutesHeader = (
				<th>
					Minutes
				</th>

			);
			var pagesHeader = (
				<th className="pageCol">
					Pages
				</th>
			);

			var readingHeader = (
				<th>
					Reading
				</th>
			)
		}

		var scoreFormat = CurrentUser.get().prefs.reading_level_format;

		if (appliedSoftMax) {
			var truncatedRow = (
				<tr className="truncatedPlaceholder">
					<td colSpan={ cellCount }>
						<button className="btn btn-link" onClick={ this.expandFromSoftMax }>
							Show { this.props.books.length - books.length } More
						</button>
					</td>
				</tr>
			);
		}

		if (this.props.showStudentCell) {
			var studentHeader = (
				<th>Student</th>
			)
		}

		return (
			<div className="textTable">
				<table className="table table-bordered">
					<tbody>
						<tr>
							<th data-tip="Most recent date of any activity during time period">
								Date
							</th>
							{ studentHeader }
							<th className="bookCol">
								Title
							</th>
							<th className="ReadingLevelCol" data-tip={ scoreFormat }>
								{ ReadingLevelFormat.getShortName(scoreFormat) }
							</th>
							<th className="quizCol" data-tip="Pass or fail">
								Quiz Score
							</th>
							<th className="writingCol">
								Other Writing
							</th>
							{ readingHeader }
						</tr>
						{ rows }
						{ truncatedRow }
					</tbody>
				</table>
			</div>
		);
	}
}

TextTable.WrappedComponent.propTypes = StrictPropTypes({
	// userID of the student for this table
	userID: PropTypes.number,

	// List of books
	books: PropTypes.array.isRequired,

	showResponseCounts: PropTypes.bool,
	showLogStats: PropTypes.bool,
	softMax: PropTypes.number,
	showStudentCell: PropTypes.bool,

	// From @connnect
	studentFirstName: PropTypes.string,
	onCellClick: PropTypes.func.isRequired,
	evaluationIDsByTextID: PropTypes.object.isRequired,
	showHistoricalDataPaywall: PropTypes.func,
	studentReadingLevel: PropTypes.number,
	showReadingLevelIcon: PropTypes.bool
});

module.exports = TextTable


// WEBPACK FOOTER //
// ./modules/components/reading/books/TextTable.js